<section class="mx-auto px-2 px-md-5">

	<!-- ############### STICKY CONTENT ############### -->
	<app-sticky-content *ngIf="stickyContentTemplates">
		<!-- pageHeader -->
		<ng-container *ngTemplateOutlet="pageHeader"></ng-container>

		<!-- more sticky content -->
		<ng-container *ngFor="let tpl of stickyContentTemplates">
			<ng-container *ngTemplateOutlet="tpl"></ng-container>
		</ng-container>
	</app-sticky-content>

	<!-- ############### SCROLLABLE CONTENT ############### -->
	<!-- pageHeader -->
	<ng-container *ngIf="!stickyContentTemplates">
		<ng-container *ngTemplateOutlet="pageHeader"></ng-container>
	</ng-container>

	<!-- scrollable content -->
	<ng-container *ngTemplateOutlet="scrollableContentTpl"></ng-container>
</section>

<!-- ######################### TEMPLATES ######################### -->
<!-- pageHeader -->
<ng-template #pageHeader>
	<div
		class="mt-5 pb-2 px-3 px-md-0"
 		[ngClass]="{'page-header--separator': pageActionTemplate}"
	>
		<div
			class="page-header--title"
			[ngClass]="{'d-inline-block': pageActionTemplate}"
		>
			{{ pageTitle }}
		</div>
		<ng-container *ngTemplateOutlet="pageActionContent"></ng-container>
	</div>
</ng-template>

<!-- pageActionContent -->
<ng-template #pageActionContent>
	<div *ngIf="pageActionTemplate" class="float-end">
		<ng-container *ngTemplateOutlet="pageActionTemplate"></ng-container>
	</div>
</ng-template>

<!-- scrollableContent -->
<ng-template #scrollableContentTpl>
	<div id="scrollableContent">
		<ng-container *ngFor="let tpl of contentTemplates">
			<ng-container *ngTemplateOutlet="tpl"></ng-container>
		</ng-container>
	</div>
</ng-template>
